import { createApplicationSettings } from 'uicomponents';
import env from './utils/env';
import { FeatureFlags } from './types/FeatureFlags.types';
import httpClient from './utils/httpClient';

const defaults: FeatureFlags = {
    EnableAfdWafCaptcha: true,
    DisableAfdCaptchaAutoSubmit: false,
};

export const { Provider: ApplicationSettingsProvider, useFeatureFlags, useSettingsLoaded } = createApplicationSettings<FeatureFlags>(
    defaults,
    env.REACT_APP_API_URL as string,
    httpClient
);
